import { getAuth, onAuthStateChanged, signInAnonymously } from "firebase/auth";

/**
 * Resolves with a Firebase user once authentication is guaranteed.
 */
export function waitForAuth() {
  const auth = getAuth();

  if (auth.currentUser) {
    return Promise.resolve(auth.currentUser);
  }

  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        unsubscribe();
        resolve(user);
      }
    });

    signInAnonymously(auth).catch(err => {
      unsubscribe();
      reject(err);
    });
  });
}
